// extracted by mini-css-extract-plugin
export default {"container":"yu3kO4k3-Ls5fHhDcvf8+A==","link":"_3rKBp-G8y-2qDYiLaCsXHw=="};